import {
  PAYSLIP_PREVIEW,
  PAYSLIP_GROUP_REPORT,
  PAYSLIP_GROUP_DETAILS,
} from '@portal/actions/actionTypes';

const initialState: reducers.PayslipReducer = {
  payslipGroupPreview: null,
  countPayslipGroup: 0,
  payslipGroupsReport: [],
  payslipGroupDetails: [],
  payslipGroupCount: 0,
};

const payslipReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PAYSLIP_GROUP_DETAILS:
      return {
        ...state,
        payslipGroupDetails: payload.rows,
        payslipGroupCount: payload.count,
      };

    case PAYSLIP_PREVIEW:
      return {
        ...state,
        payslipGroupPreview: payload,
      };

    case PAYSLIP_GROUP_REPORT:
      return {
        ...state,
        payslipGroupsReport: payload.rows,
        countPayslipGroup: payload.count,
      };

    default:
      return state;
  }
};

export default payslipReducer;
